import {ValueObject} from '@s-ui/domain'

import AdEntityLegacy from '../../ads/Entities/AdEntityLegacy.js'
import {AlertInteractionUserAlertsValueObject} from './AlertInteractionUserAlertsValueObject.js'

export class MatchUserAlertsValueObject extends ValueObject {
  #ad
  #alertInteraction

  constructor({ad, alertInteraction}) {
    super()
    this.#ad = ad
    this.#alertInteraction = alertInteraction
  }

  static create({ad, alertInteraction}) {
    const adEntityLegacy = AdEntityLegacy.create(ad)
    const alertInteractionValueObject = AlertInteractionUserAlertsValueObject.create(alertInteraction)

    return new MatchUserAlertsValueObject({
      ad: adEntityLegacy,
      alertInteraction: alertInteractionValueObject
    })
  }

  get ad() {
    return this.#ad.value
  }

  get alertInteraction() {
    return this.#alertInteraction.getValue()
  }

  getIsMissed() {
    return this.#alertInteraction.getIsMissed()
  }

  getIsRecent() {
    return this.#alertInteraction.getIsRecent()
  }

  getValue() {
    return {
      ad: this.ad,
      alertInteraction: this.alertInteraction
    }
  }

  toJSON() {
    return {
      ad: this.#ad.toJSON(),
      alertInteraction: this.#alertInteraction.toJSON()
    }
  }
}
